"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  en: {
    orders: {
      actions: {
        addNewOrder: 'Add new Order',
        all: 'All Orders'
      },
      listPage: {
        title: 'Orders',
        table: {
          filter: {
            number: 'Number'
          },
          columns: {
            contact: 'Contact',
            dateOfOrder: 'Date of Order',
            number: 'Number',
            offer: 'Offer',
            opportunity: 'Opportunity',
            owner: 'Owner',
            state: 'State',
            total: 'Total',
            totalUserCurrency: 'Total in {currency}'
          }
        }
      },
      order: {
        newEntity: 'New Order',
        contact: {
          label: 'Contact',
          helperText: '',
          helperTextPreview: ''
        },
        commissionTotal: {
          label: 'Commission Total',
          helperText: '',
          helperTextPreview: ''
        },
        currency: {
          label: 'Currency',
          helperText: '',
          helperTextPreview: ''
        },
        dateOfOrder: {
          label: 'Date or order',
          helperText: '',
          helperTextPreview: ''
        },
        number: {
          label: 'Number',
          helperText: 'To get automatically generated number leave the field empty.',
          helperTextPreview: ''
        },
        offer: {
          label: 'Offer',
          helperText: '',
          helperTextPreview: ''
        },
        opportunity: {
          label: 'Opportunity',
          helperText: '',
          helperTextPreview: ''
        },
        owner: {
          label: 'Owner',
          helperText: '',
          helperTextPreview: ''
        },
        salesMargin: {
          label: 'Sales Margin',
          helperText: '',
          helperTextPreview: ''
        },
        subjects: {
          title: 'Subjects',
          discount: {
            label: 'Discount',
            helperText: '',
            helperTextPreview: ''
          },
          commission: {
            label: 'Commission',
            helperText: '',
            helperTextPreview: ''
          },
          list: {
            package: 'Pack size'
          },
          listPrice: {
            label: 'List Price',
            helperText: '',
            helperTextPreview: ''
          },
          price: {
            label: 'Price',
            helperText: '',
            helperTextPreview: ''
          },
          product: {
            label: 'Product',
            helperText: '',
            helperTextPreview: ''
          },
          quantity: {
            label: 'Quantity',
            helperText: '',
            helperTextPreview: ''
          },
          salesMargin: {
            label: 'Sales Margin',
            helperText: '',
            helperTextPreview: ''
          },
          subjectTotal: {
            label: 'Subject Total',
            helperText: '',
            helperTextPreview: ''
          },
          unit: {
            label: 'Unit',
            helperText: '',
            helperTextPreview: ''
          }
        },
        total: {
          label: 'Total',
          helperText: '',
          helperTextPreview: ''
        },
        numberOfSubjects: '{number, plural, =0 {no items} one {1 item} other {{number} items}}'
      },
      myOrdersScoringBlog: {
        title: 'My Orders'
      },
      ordersList: 'Orders'
    }
  }
};
var _default = messages;
exports.default = _default;